import React, { useState } from "react";
import { buildPublicFileUrl } from "../../../../services/config";
import { PiXFill } from "react-icons/pi";

const { forwardRef, useRef, useImperativeHandle } = React;

const ShowImageModal = forwardRef(
  ({ imagePath, clearImagePath, isVendor }, ref) => {
    const [showModal, setShowModal] = useState(false);

    useImperativeHandle(ref, () => ({
      showModal() {
        setShowModal(!showModal);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      afterSubmit() {},
    }));

    const closeModal = () => {
      setShowModal(false);
      clearImagePath();
    };

    return (
      <>
        <div
          className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
            !showModal && "hidden"
          }`}
        ></div>
        <div
          className={`w-[340px] py-4 h-[360px] bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] opacity-0 invisible ${
            showModal && "!mt-20 !opacity-100 !visible"
          }`}
        >
          <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
            <h4>عکس</h4>
            <PiXFill
              onClick={closeModal}
              size={30}
              className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
            />
          </div>
          <div className="w-full h-full mt-2 overflow-hidden">
            {imagePath ? (
              <>
                <img
                  className="h-[260px] mx-auto"
                  src={buildPublicFileUrl(imagePath, { vendor: isVendor })}
                  alt=""
                />
              </>
            ) : null}
          </div>
        </div>
      </>
    );
  }
);
export default ShowImageModal;
